// @ts-nocheck
import {useNavigate} from "react-router-dom";
import {BaseButton, SectionHeader} from "@/components";
import HorserImg from "../../../../../assets/images/hipismo-section/horser.svg";
import HorsesBg from "../../../../../assets/images/hipismo-section/horses-background.png";
import PollaImg from "../../../../../assets/images/hipismo-section/polla-royal.svg";
import SellaImg from "../../../../../assets/images/hipismo-section/sella-5y6.svg";
import {useAuthStore} from "../../../../../store/useAuth.store";

const hipismoSectionCls =
  "section-bleed relative overflow-hidden flex flex-col items-center justify-start gap-6 pt-8 pb-10 box-border min-h-[420px] max-[900px]:min-h-[auto] max-[900px]:py-8 max-[900px]:px-0";
const hipismoBgCls = "absolute inset-0 w-full h-full object-cover object-center z-0";
const hipismoOverlayCls =
  "absolute inset-0 z-[var(--z-base)] bg-[linear-gradient(180deg,rgba(0,0,0,0.25)_0%,rgba(0,0,0,0.1)_50%,rgba(0,0,0,0.45)_100%)]";
const hipismoContentCls = "relative z-[2] flex flex-col items-center gap-6 w-full px-6 box-border max-[900px]:gap-5";
const hipismoButtonStyle = {
  ["--btn-outline-color" as never]: "var(--color-hipismo)",
  ["--btn-outline-fill" as never]: "var(--color-hipismo)",
  ["--btn-outline-text-hover" as never]: "var(--color-text-inverse)",
  ["--btn-outline-glow" as never]: "rgba(255, 193, 33, 0.5)",
};
/* Desktop: 3 in a row. Mobile: 2 top + 1 centered */
const hipismoGridCls =
  "grid [grid-template-columns:repeat(3,1fr)] gap-4 w-full max-w-[560px] " +
  "max-[640px]:[grid-template-columns:repeat(2,1fr)] max-[640px]:gap-3";
const hipismoCardCls =
  "group cursor-pointer rounded-[var(--radius-lg)] transition-transform duration-300 flex items-center justify-center " +
  "py-4 px-3 hover:-translate-y-[3px]";
/* 3rd card (horser) spans 2 cols on mobile to center it */
const hipismoCardLastCls =
  "max-[640px]:[grid-column:1/-1] max-[640px]:max-w-[calc(50%-6px)] max-[640px]:mx-auto max-[640px]:w-full";
const hipismoLogoImgCls =
  "block h-[80px] max-w-[160px] w-auto object-contain transition-[filter] duration-300 " +
  "group-hover:[filter:drop-shadow(0_0_8px_var(--color-hipismo))_drop-shadow(0_0_20px_rgba(255,193,33,0.7))_brightness(1.08)] " +
  "max-[640px]:h-[60px] max-[640px]:max-w-[130px]";
const hipismoLogoFlareCls =
  "pointer-events-none absolute inset-0 opacity-0 [mask-size:contain] [mask-repeat:no-repeat] [mask-position:center] [-webkit-mask-size:contain] [-webkit-mask-repeat:no-repeat] [-webkit-mask-position:center] [mix-blend-mode:screen] group-hover:animate-[hipismo-sweep_0.9s_ease-out]";

const cards = [
  {id: 1, src: PollaImg, alt: "Polla Royal", route: ""},
  {id: 2, src: SellaImg, alt: "Sella 5 y 6", route: ""},
  {id: 3, src: HorserImg, alt: "Horser", route: ""},
];

const HipismoSection = () => {
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  return (
    <div className={hipismoSectionCls}>
      <img
        src={HorsesBg}
        alt="Hipismo background"
        className={hipismoBgCls}
      />
      <div className={hipismoOverlayCls} />
      <div className={hipismoContentCls}>
        <SectionHeader
          eyebrow="Hipismo"
          title="La pasión que corre por nuestras venas"
          highlight="pasión"
          align="center"
          variant="hero"
        />

        {/* Logo grid: 3 cols desktop / 2+1 centered mobile */}
        <div className={hipismoGridCls}>
          {cards.map((card, i) => (
            <div
              key={card.id}
              className={`${hipismoCardCls}${i === cards.length - 1 ? ` ${hipismoCardLastCls}` : ""}`}
              onClick={() => {
                if (!card.route) return;
                authStatus === "authenticated" ? navigate(`/${card.route}`) : handleShowAuthModal();
              }}
            >
              <span className="relative inline-flex items-center justify-center">
                <img
                  src={card.src}
                  alt={card.alt}
                  className={hipismoLogoImgCls}
                />
                <span
                  aria-hidden="true"
                  className={hipismoLogoFlareCls}
                  style={{
                    maskImage: `url(${card.src})`,
                    WebkitMaskImage: `url(${card.src})`,
                    backgroundImage:
                      "linear-gradient(115deg, transparent 30%, rgba(255,255,255,0.25) 42%, rgba(255,255,255,0.95) 50%, rgba(255,193,33,0.85) 56%, transparent 68%)",
                    backgroundSize: "220% 100%",
                    backgroundPosition: "180% 50%",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </span>
            </div>
          ))}
        </div>

        {/* CTA — separate row, centered */}
        <BaseButton
          variant="outline"
          size="md"
          onClick={() => (authStatus === "authenticated" ? navigate("/horses") : handleShowAuthModal())}
          style={hipismoButtonStyle}
          className="min-w-[170px]"
        >
          Ir a todos
        </BaseButton>
      </div>
    </div>
  );
};

export default HipismoSection;
